"use client";

import { c as _c } from "react/compiler-runtime";
import { ADMIN_TEXTS } from "@/constants/admin-texts";
import type { StreamingPlatform } from "@/features/auth/api/types";
import { DetailPanel, DetailPanelDivider, DetailPanelRow, DetailPanelValue } from "@/shared/ui";
import { formatPlatformUrl, PlatformIcon } from "./platform-icon";
import classes from "./streaming-channels-panel.module.scss";
export function StreamingChannelsPanel(t0) {
  const $ = _c(10);
  const {
    platforms,
    emptyMessage: t1
  } = t0;
  const emptyMessage = t1 === undefined ? ADMIN_TEXTS.empty.noChannel : t1;
  let T0;
  let t2;
  let t3;
  if ($[0] !== emptyMessage || $[1] !== platforms) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const visible = platforms.filter(_temp);
      if (visible.length === 0) {
        let t4;
        if ($[5] !== emptyMessage) {
          t4 = <p className={classes.emptyMessage}>{emptyMessage}</p>;
          $[5] = emptyMessage;
          $[6] = t4;
        } else {
          t4 = $[6];
        }
        t3 = t4;
        break bb0;
      }
      T0 = DetailPanel;
      t2 = visible.map((p_0, i) => <div key={`${p_0.platform}-${p_0.url}-${i}`}><DetailPanelRow><div className={classes.platformIconCell}><PlatformIcon platform={p_0.platform} /></div><DetailPanelValue><span className={classes.platformUrl}>{formatPlatformUrl(p_0.url)}</span></DetailPanelValue></DetailPanelRow>{i < visible.length - 1 && <DetailPanelDivider />}</div>);
    }
    $[0] = emptyMessage;
    $[1] = platforms;
    $[2] = T0;
    $[3] = t2;
    $[4] = t3;
  } else {
    T0 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[7] !== T0 || $[8] !== t2) {
    t4 = <T0>{t2}</T0>;
    $[7] = T0;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(p) {
  return (p.platform?.trim() ?? "") !== "" || (p.url?.trim() ?? "") !== "";
}